var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor get-location" }, [
    _c("div", { staticClass: "get-location-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [_vm._v("Message")]),
      _vm._v(" "),
      _c(
        "div",
        { key: "message", staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: "Type message",
              rows: 1,
            },
            model: {
              value: _vm.clone.message,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "message", $$v)
              },
              expression: "clone.message",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "attribute-picker-section" },
        [
          _c("span", { staticClass: "sectionTitle" }, [
            _vm._v(" Save Latitude"),
          ]),
          _vm._v(" "),
          _c(
            "a-popover",
            {
              attrs: { trigger: "click", overlayClassName: "no-padding" },
              model: {
                value: _vm.latitudePickerVisible,
                callback: function ($$v) {
                  _vm.latitudePickerVisible = $$v
                },
                expression: "latitudePickerVisible",
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "content" }, slot: "content" },
                [
                  _c("AttributePicker", {
                    attrs: {
                      "default-selected": _vm.clone.setLatitude,
                      pick: _vm.onLatitudeAttributePicked,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "attribute-input" }, [
                _c("div", { staticClass: "attribute-input-text-wrapper" }, [
                  _vm.$_.isEmpty(_vm.clone.setLatitude)
                    ? _c(
                        "div",
                        { staticClass: "attribute-input-placeholder" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.chooseAttributeType")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "single-attribute-style",
                          class: { active: _vm.latitudePickerVisible },
                        },
                        [
                          _c("AttributeIconPreview", {
                            attrs: { attribute: _vm.clone.setLatitude },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.clone.setLatitude.toLocaleLowerCase())
                            ),
                          ]),
                        ],
                        1
                      ),
                ]),
                _vm._v(" "),
                !_vm.$_.isEmpty(_vm.clone.setLatitude)
                  ? _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" expand_more "),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "attribute-picker-section" },
        [
          _c("span", { staticClass: "sectionTitle" }, [
            _vm._v(" Save Longitude"),
          ]),
          _vm._v(" "),
          _c(
            "a-popover",
            {
              attrs: { trigger: "click", overlayClassName: "no-padding" },
              model: {
                value: _vm.longitudePickerVisible,
                callback: function ($$v) {
                  _vm.longitudePickerVisible = $$v
                },
                expression: "longitudePickerVisible",
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "content" }, slot: "content" },
                [
                  _c("AttributePicker", {
                    attrs: {
                      "default-selected": _vm.clone.setLongitude,
                      pick: _vm.onLongitudeAttributePicked,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "attribute-input" }, [
                _c("div", { staticClass: "attribute-input-text-wrapper" }, [
                  _vm.$_.isEmpty(_vm.clone.setLongitude)
                    ? _c(
                        "div",
                        { staticClass: "attribute-input-placeholder" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.chooseAttributeType")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "single-attribute-style",
                          class: { active: _vm.longitudePickerVisible },
                        },
                        [
                          _c("AttributeIconPreview", {
                            attrs: { attribute: _vm.clone.setLongitude },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.clone.setLongitude.toLocaleLowerCase())
                            ),
                          ]),
                        ],
                        1
                      ),
                ]),
                _vm._v(" "),
                !_vm.$_.isEmpty(_vm.clone.setLongitude)
                  ? _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" expand_more "),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle" }, [_vm._v("Initial Location")]),
      _vm._v(" "),
      _c(
        "div",
        { key: "initial-location", staticClass: "selects-wrapper" },
        [
          _c("span", [_vm._v("Default Selected Country")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              attrs: {
                value: _vm.clone.initialCountry,
                placeholder: "Select Country",
                "filter-option": _vm.filterOption,
                "option-filter-prop": "children",
                "show-search": "",
              },
              on: { change: _vm.handleCountryChange },
            },
            _vm._l(_vm.countries, function (country) {
              return _c(
                "a-select-option",
                { key: country.iso2, attrs: { value: country.iso2 } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(country.name) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Default Selected State")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              attrs: {
                value: _vm.clone.initialState,
                placeholder: "Select State",
                "filter-option": _vm.filterOption,
                "option-filter-prop": "children",
                "show-search": "",
              },
              on: { change: _vm.handleStateChange },
            },
            _vm._l(_vm.states, function (state) {
              return _c(
                "a-select-option",
                { key: state.state_code, attrs: { value: state.state_code } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(state.name) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Default Selected City")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              attrs: {
                value: _vm.clone.initialCity,
                placeholder: "Select City",
                "filter-option": _vm.filterOption,
                "option-filter-prop": "children",
                "show-search": "",
              },
              on: { change: _vm.handleCityChange },
            },
            _vm._l(_vm.cities, function (city) {
              return _c(
                "a-select-option",
                { key: city.id, attrs: { value: city.id } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(city.name) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }